export enum UserRoles {
    SUPER_ADMINISTRATOR = 'SUPER_ADMINISTRATOR',
    LEARNER = 'LEARNER'
}
